"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var Select_component_1 = __importDefault(require("../../Select/Select.component"));
var OPTIONS = [
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '30', label: '30' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
];
var PagingSizeSelector = function (_a) {
    var pagingSize = _a.pagingSize, position = _a.position, handleChangeSize = _a.handleChangeSize;
    var currentValue = OPTIONS.find(function (option) { return option.value === pagingSize.toString(); });
    var handleChange = function (option) {
        handleChangeSize(option.value);
    };
    return ((0, jsx_runtime_1.jsx)(Select_component_1.default, { "aria-label": "Paging size selector", size: "sm", position: position, currentValue: currentValue, options: OPTIONS, onChangeOption: handleChange }, void 0));
};
exports.default = PagingSizeSelector;
